import {analyticsLogEvent} from '../api'

const eventName = 'search_layer'

type EventSearchLayerAction = 'open' | 'close'

interface Parameters {
    action: EventSearchLayerAction
}

/**
 * Tracks a search layer event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventSearchLayerAction} params.action - Action of the event.
 */
export function analyticsEventSearchLayer({action}: Parameters): void {
    const eventDetails = {
        layer_action: action,
    }

    analyticsLogEvent(eventName, eventDetails)
}
